import {FullScreenStateEnum} from '../../../../enums/full-screen-state.enum';
import {VideoStateEnum} from '../../../../enums/video-state.enum';
import VideoClipModel from '../../../../models/video-clip.model';
import OverlayModel from '../../../../models/overlay.model';
import AudioTrackModel from '../../../../models/audio-track.model';
import FormModel from '../../../../models/form.model';
import {ActionAbstract} from '../../../../models/actions/action.abstract';
import ProjectModel from '../../../../models/project.model';
import SceneModel from '../../../../models/scene.model';

export default class VideoState {
    videoClips: Array<VideoClipModel>;
    videoScenesData: Array<SceneModel>;
    overlays: Array<OverlayModel>;
    actions: Array<ActionAbstract>;
    audioTracks: Array<AudioTrackModel>;
    forms: Array<FormModel>;
    videoError: Error;
    currentVideoTime: number;
    currentVideoFrame: number;
    currentScene: VideoClipModel;
    currentSceneClip: SceneModel;
    isCurrentSceneLoaded: boolean;
    nextScene: VideoClipModel;
    actualVideoState: VideoStateEnum;
    userVolume: number;
    masterVideoVolume: number;
    totalTime: number;
    fullScreenState: FullScreenStateEnum;
    navigateToTime: number;
    startSceneTime: number;
    userResolution: string;
    timelineVisibility: boolean;
    resolutionMenuVisibility: boolean;
    spaceKeyListener: boolean;
    isInMobilePreviewMode: boolean;
    project: ProjectModel;
    preview: boolean;
    imagesPreloaded: boolean;
    notAvailableResolution: string[];
    isIOSFullScreenDisable: boolean;
}

export const initializeState = (): VideoState => {
    return {
        actions: [],
        videoClips: Array<VideoClipModel>(),
        videoScenesData: Array<any>(),
        overlays: Array<OverlayModel>(),
        audioTracks: Array<AudioTrackModel>(),
        forms: Array<FormModel>(),
        videoError: null,
        currentVideoTime: 0,
        currentVideoFrame: 0,
        currentScene: null,
        currentSceneClip: null,
        isCurrentSceneLoaded: false,
        nextScene: null,
        actualVideoState: VideoStateEnum.Buffering,
        userVolume: 100,
        masterVideoVolume: 100,
        totalTime: 0,
        fullScreenState: FullScreenStateEnum.Inactive,
        navigateToTime: 0,
        startSceneTime: 0,
        userResolution: null,
        timelineVisibility: false,
        resolutionMenuVisibility: false,
        spaceKeyListener: true,
        isInMobilePreviewMode: false,
        project: {
            meta: {
            }
        },
        preview: false,
        imagesPreloaded: false,
        notAvailableResolution: [],
        isIOSFullScreenDisable: true
    };
};
